import { isAdminPath, isAdminSubdomainHost } from './siteRouting';

const TRUE_VALUES = new Set(['1', 'true', 'yes', 'on']);

export const isMaintenanceModeEnabled = (rawValue = process.env.REACT_APP_MAINTENANCE_MODE) =>
  TRUE_VALUES.has(String(rawValue || '').trim().toLowerCase());

export const shouldShowMaintenanceScreen = (
  pathname,
  enabled = isMaintenanceModeEnabled(),
  adminHost = isAdminSubdomainHost(),
) => {
  const isAdminEntry = isAdminPath(pathname) || (adminHost && pathname === '/login');
  return Boolean(enabled && !isAdminEntry);
};
